// © 2026 AttainIP Engineering
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { RequireAuth } from '@/components/RequireAuth';
import { RequirePlatformAdmin } from '@/components/RequirePlatformAdmin';
import { LoginPage } from '@/pages/LoginPage';
import { CallbackPage } from '@/pages/CallbackPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { UsersPage } from '@/pages/UsersPage';
import { UserDetailPage } from '@/pages/UserDetailPage';
import { AnalysesPage } from '@/pages/AnalysesPage';
import { FeedbackPage } from '@/pages/FeedbackPage';
import { EventsPage } from '@/pages/EventsPage';
import { PaymentsPage } from '@/pages/PaymentsPage';
import { PublicChatsPage } from '@/pages/PublicChatsPage';
import { EnterprisesPage } from '@/pages/EnterprisesPage';
import { EnterpriseDetailPage } from '@/pages/EnterpriseDetailPage';
import { CaseOwnershipPage } from '@/pages/CaseOwnershipPage';

// This console is platform_admin-only (Attain operators); every route sits
// behind RequireAuth, which admits platform_admin only. The landing page is the
// Dashboard. (org_admin/firm-admin management lives in the enterprise product,
// not here — RFC-0212 A2 correction.)
function DefaultRoute() {
  return <Navigate to="/dashboard" replace />;
}

export function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<CallbackPage />} />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<DefaultRoute />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:userId" element={<UserDetailPage />} />
          <Route path="analyses" element={<AnalysesPage />} />
          <Route path="public-chats" element={<PublicChatsPage />} />
          <Route path="feedback" element={<FeedbackPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="events" element={<EventsPage />} />
          <Route
            path="case-ownership"
            element={
              <RequirePlatformAdmin>
                <CaseOwnershipPage />
              </RequirePlatformAdmin>
            }
          />
          <Route
            path="enterprises"
            element={
              <RequirePlatformAdmin>
                <EnterprisesPage />
              </RequirePlatformAdmin>
            }
          />
          <Route
            path="enterprises/:orgId"
            element={
              <RequirePlatformAdmin>
                <EnterpriseDetailPage />
              </RequirePlatformAdmin>
            }
          />
        </Route>
        <Route path="*" element={<DefaultRoute />} />
      </Routes>
    </BrowserRouter>
  );
}
